export const SET_LOADING = "SET_LOADING";
export const SET_INTERCOM = "SET_INTERCOM";
export const SET_CURRENT_MODULE= "SET_CURRENT_MODULE";
